class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    document.addEventListener('DOMContentLoaded', function() {
      document.documentElement.classList.add('showing-modal');
    });

    console.log('Modal opened');

    if ($('body').hasClass('template-index') && $(window).width() < 990) {
      $('.template-index .fake-filter-slider').slick('slickPause');
    }
    

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('showing-modal');
    console.log('Modal closed');

  }
}

customElements.define('details-modal', DetailsModal);

///////////////////////////////////////////////////////////////////////////////
//////// Main Navigation 
///////////////////////////////////////////////////////////////////////////////

  
var dropdownTimeout;
$(".desktop-navbar-nav-dropdown a").hover(
  function () {
    var $this = $(this);


    dropdownTimeout = setTimeout(function () {
      $(".menu-bg").addClass("menu-visible");
      $('.desktop-navbar-nav-dropdown').removeClass('open');
      $this.parents('.desktop-navbar-nav-dropdown').addClass('open');
      $this.parents('.desktop-navbar-nav-dropdown').find('.desktop-navbar-nav-dropdown-menu .nav-list-level-2 a').attr('tabindex', '0');
      $this.parents('.desktop-navbar-nav-dropdown').find('.desktop-navbar-nav-dropdown-menu .mega-menu-nav-collection-inner[aria-expanded="true"] a').attr('tabindex', '0');

    }, 400);
  },
  function () {
    clearTimeout(dropdownTimeout);
  }
);

var dropdownTimeout;
$(".desktop-navbar-nav-regular-link").hover(
  function () {
    var $this = $(this);


    dropdownTimeout = setTimeout(function () {
      $(".menu-bg").removeClass("menu-visible");
      $('.desktop-navbar-nav-dropdown').removeClass('open');
      $this.parents('.desktop-navbar-nav-dropdown').addClass('open');

    }, 400);
  },
  function () {
    clearTimeout(dropdownTimeout);
  }
);

$(".header__inline-menu").on('mouseleave', function () {
  $(".menu-bg").removeClass("menu-visible");
  $('.desktop-navbar-nav-dropdown').removeClass('open');
  $('.desktop-navbar-nav-dropdown-menu a').attr('tabindex', '-1');
})

function removeClassWithPrefix(element, classPrefix) {
  var regex = new RegExp("(^|\\s)" + classPrefix + "\\S+", "g");
  element.removeClass(function (index, css) {
    return (css.match(regex) || []).join(" ");
  });
}

$(document).on("touchstart touchend", ".collection-hover:not(.collection-hover-active)", function (e) {
  e.preventDefault();
  var $this = $(this);
  var menuHandle = $this.attr("data-desktop-nav-collection");

  $(".collection-hover").removeClass("collection-hover-active");

  $this.parents(".mega-menu").find(".mega-menu-nav-collection-inner").attr("aria-expanded", false);
  $this.parents(".mega-menu").find(".mega-menu-nav-collection-inner a").attr("tabindex", "-1");

  setTimeout(function () {
    $this.addClass("collection-hover-active");
    $this
    .parents(".mega-menu")
    .find('.mega-menu-nav-collection-inner[data-desktop-nav-collection="' + menuHandle + '"]')
    .attr("aria-expanded", true);

    $this
    .parents(".mega-menu")
    .find('.mega-menu-nav-collection-inner[data-desktop-nav-collection="' + menuHandle + '"] a')
    .attr("tabindex", "0");
  }, 100);
});

$(document).on("touchstart", ".dropdown.open a.desktop-navbar-nav-dropdown-toggle", function (e) {
  var $this = $(this);
  var anchorURL = $this.attr('href');

  window.location.href = anchorURL;

});

$(document).on("touchstart touchend", ".dropdown a.desktop-navbar-nav-dropdown-toggle", function (e) {
  e.preventDefault();
  var $this = $(this);

  $(".menu-bg").addClass("menu-visible");
  $('.desktop-navbar-nav-dropdown').removeClass('open');
  $this.parents('.desktop-navbar-nav-dropdown').addClass('open');
  $this.parents('.desktop-navbar-nav-dropdown').find('.desktop-navbar-nav-dropdown-menu .nav-list-level-2 a').attr('tabindex', '0');
  $this.parents('.desktop-navbar-nav-dropdown').find('.desktop-navbar-nav-dropdown-menu .mega-menu-nav-collection-inner[aria-expanded="true"] a').attr('tabindex', '0');

});

function is_touch_enabled() {
  return ( 'ontouchstart' in window ) ||
         ( navigator.maxTouchPoints > 0 ) ||
         ( navigator.msMaxTouchPoints > 0 );
}

if ($(window).width() > 767 && is_touch_enabled()) {

  
      $(window).on('scroll', function(){
        if ($('.desktop-navbar-nav-dropdown.open').length){
          $(".menu-bg").removeClass("menu-visible");
          $('.desktop-navbar-nav-dropdown').removeClass('open');
          $('.desktop-navbar-nav-dropdown-menu a').attr('tabindex', '-1');
        }
      });
   
}

$(document).on("focusin focusout", ".collection-hover:not(.collection-hover-active)", function (e) {
  if (!$("body").hasClass("keyboard-focus")) {
    return;
  }

  e.preventDefault();
  var $this = $(this);
  var menuHandle = $this.attr("data-desktop-nav-collection");

  $(".collection-hover").removeClass("collection-hover-active");

  $this.parents(".mega-menu").find(".mega-menu-nav-collection-inner").attr("aria-expanded", false);
  $this.parents(".mega-menu").find(".mega-menu-nav-collection-inner a").attr("tabindex", "-1");
  setTimeout(function () {
    $this.addClass("collection-hover-active");
    $this
      .parents(".mega-menu")
      .find('.mega-menu-nav-collection-inner[data-desktop-nav-collection="' + menuHandle + '"]')
      .attr("aria-expanded", true);
      $this
    .parents(".mega-menu")
    .find('.mega-menu-nav-collection-inner[data-desktop-nav-collection="' + menuHandle + '"] a')
    .attr("tabindex", "0");
  }, 100);
});

$(document).on("keydown", ".dropdown.open a.desktop-navbar-nav-dropdown-toggle", function (e) {
  if (!$("body").hasClass("keyboard-focus")) {
    return;
  }

  var $this = $(this);
  var anchorURL = $this.attr('href');

  if (e.key === "Enter") { // Enter key
    window.location.href = anchorURL;
  }
});

$(document).on("focusin", ".desktop-navbar-nav-regular-link", function (e) {
  if (!$("body").hasClass("keyboard-focus")) {
    return;
  }

  $(".menu-bg").removeClass("menu-visible");
  $('.desktop-navbar-nav-dropdown').removeClass('open');

});

$(document).on("focusin", ".dropdown a.desktop-navbar-nav-dropdown-toggle", function (e) {
  if (!$("body").hasClass("keyboard-focus")) {
    return;
  }

  e.preventDefault();
  var $this = $(this);
  var $dropdown = $this.parents('.desktop-navbar-nav-dropdown');

  $this.attr('aria-expanded', 'true');

  if (!$dropdown.hasClass('open')) {
    $(".menu-bg").addClass("menu-visible");
    $('.desktop-navbar-nav-dropdown').removeClass('open');
    $dropdown.addClass('open');
    $dropdown.find('.desktop-navbar-nav-dropdown-menu .nav-list-level-2 a').attr('tabindex', '0');
    $dropdown.find('.desktop-navbar-nav-dropdown-menu .mega-menu-nav-collection-inner[aria-expanded="true"] a').attr('tabindex', '0');
    $dropdown.find('.second-chances-nav a').attr('tabindex', '0');
  }
});

$(document).on("focusout", ".desktop-navbar-nav-dropdown", function (e) {
  if (!$("body").hasClass("keyboard-focus")) {
    return;
  }

  var $this = $(this);

  setTimeout(function () {
    if (!$this.find(':focus').length && !$(document.activeElement).parents('.desktop-navbar-nav-dropdown').length) {
      $(".menu-bg").removeClass("menu-visible");
      $this.removeClass('open');
      $this.attr('aria-expanded', 'false');
      $this.find('.desktop-navbar-nav-dropdown-menu a').attr('tabindex', '-1');
      $this.find('.second-chances-nav a').attr('tabindex', '-1');
    }
  }, 100);
});

$(document).on("keydown", ".desktop-navbar-nav-regular-link, .desktop-navbar-nav-dropdown-toggle", function (e) {
  if (!$("body").hasClass("keyboard-focus")) {
    return;
  }

  var $this = $(this);
  // Include both types of elements in the collection
  var $navItems = $(".desktop-navbar-nav-regular-link:visible, .desktop-navbar-nav-dropdown-toggle:visible");
  var currentIndex = $navItems.index($this);
  var nextIndex;

  if (e.key === "ArrowLeft" || e.key === "ArrowRight") { // Left or Right arrow key
    e.preventDefault();

    if (e.key === "ArrowLeft") {
      nextIndex = currentIndex > 0 ? currentIndex - 1 : $navItems.length - 1;
    } else {
      nextIndex = currentIndex < $navItems.length - 1 ? currentIndex + 1 : 0;
    }

    $navItems.eq(nextIndex).focus();
  }
});




$(document).on("keydown", ".collection-hover", function (e) {
  if (!$("body").hasClass("keyboard-focus")) {
    return;
  }

  var $this = $(this);
  var $innerMenu = $this.closest(".mega-menu").find('.mega-menu-nav-collection-inner[aria-expanded="true"]');
  var $links = $innerMenu.find("a:visible");

  if (e.key === "ArrowRight") { // Right arrow key
    e.preventDefault();
    $links.first().focus();
    $this.data('return-link', this);
  }
});

$(document).on("keydown", ".mega-menu-nav-collection-inner a.navigation-product-link", function (e) {
  if (!$("body").hasClass("keyboard-focus")) {
    return;
  }

  var $this = $(this);
  var $links = $this.parent().find("a:visible");
  var currentIndex = $links.index($this);
  var nextIndex;

  if (e.key === "ArrowLeft" || e.key === "ArrowRight") { // Left or Right arrow key
    e.preventDefault();

    if (e.key === "ArrowLeft") {
      nextIndex = currentIndex > 0 ? currentIndex - 1 : $links.length - 1;
    } else {
      nextIndex = currentIndex < $links.length - 1 ? currentIndex + 1 : 0;
    }

    $links.eq(nextIndex).focus();
  }
});

$(document).on('keydown', '.mega-menu-nav-collection-inner[aria-expanded="true"] .product-ribbon-flex-item:first-child a.navigation-product-link', function (e) {
  if (!$("body").hasClass("keyboard-focus")) {
    return;
  }

  if (e.shiftKey && e.key === "Tab") {
    e.preventDefault();
    var $this = $(this);
    var innerMenuHandle = $this.parents('.mega-menu-nav-collection-inner').attr('data-desktop-nav-collection');
    var $collectionHover = $this.closest('.desktop-navbar-nav-dropdown').find('.collection-hover[data-desktop-nav-collection="'+ innerMenuHandle +'"]');

    console.log(innerMenuHandle);
   
      $collectionHover.focus();
    
  }
});



function is_touch_enabled() {
  return ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0);
}

if ($(window).width() > 767 && is_touch_enabled()) {
  $(window).on('scroll', function () {
    if ($('.desktop-navbar-nav-dropdown.open').length) {
      $(".menu-bg").removeClass("menu-visible");
      $('.desktop-navbar-nav-dropdown').removeClass('open');
    }
  });
}







var tOut;
$(".mega-menu-nav-col a.collection-hover").hover(
  function () {
    var $this = $(this);
    var menuHandle = $this.attr("data-desktop-nav-collection");
    tOut = setTimeout(function () {
      $this.parents(".mega-menu").find(".mega-menu-nav-collection-inner").attr("aria-expanded", false);

      setTimeout(function () {
        $this
        .parents(".mega-menu")
        .find('.mega-menu-nav-collection-inner[data-desktop-nav-collection="' + menuHandle + '"]')
        .attr("aria-expanded", true);
      }, 100);
    }, 200);
  },
  function () {
    clearTimeout(tOut);
  }
);

/////// Mobile Nav
var is_iPad = navigator.userAgent.match(/iPad/i) != null;
if (is_iPad) {
  $("body").addClass("device-is-ipad");
   
}

$(document).on("click", ".mobile-navbar-btn", function (event) {
  var $this = $(this);
  var menuHandle = $this.attr("id");

  if ($this.hasClass('mobile-navbar-link-active')) {
    $this.addClass("stay-bolded");
    $this.removeClass("mobile-navbar-link-active");
    $this.parent().removeClass("mobile-navbar-link-active-wrapper");
    setTimeout(function () {
      $this.removeClass("stay-bolded");
    }, 0750);
  } else {

    $('.mobile-navbar-link-active').addClass("stay-bolded");

    setTimeout(function(){
      $('.stay-bolded:not(.mobile-navbar-link-active)').removeClass('stay-bolded')

    },0700);

   

    $(".mobile-navbar-btn").removeClass("mobile-navbar-link-active");
    $('.mobile-navbar-trigger').removeClass("mobile-navbar-link-active-wrapper");
    $(".mobile-nav-trigger-link").attr("aria-hidden", true);

    $this.addClass("mobile-navbar-link-active");
    $this.parent().addClass("mobile-navbar-link-active-wrapper");
    $(".mobile-navbar-content-inner").attr("aria-hidden", true);
    $this.parents(".mobile-navbar-trigger").find(".mobile-nav-trigger-link").attr("aria-hidden", false);

    setTimeout(function () {
      $('.mobile-navbar-content-inner[aria-label="' + menuHandle + '"]').attr("aria-hidden", false);
    }, 0100);

    setTimeout(function () {
      $('.mobile-navbar-content-inner:not([aria-label="' + menuHandle + '"])').scrollTop(0);
      $('.mobile-navbar-content-inner:not([aria-label="' + menuHandle + '"]) .product-ribbon-flex-container').scrollLeft(0);
    }, 0200);
  }
});

$(".mobile-navbar-ribbon.mobile-navbar-link-colors span").each(function () {
  var $this = $(this);

  if ($this.width() > 59.95) {
    $this.addClass("long-title");
  }
});

$(".mobile-navbar-content-inner").on("scroll", function () {
  var $this = $(this);

  if ($this.scrollTop() > 3) {
    $(".mobile-navbar-tab-trigger").addClass("nav-scrolled");
  } else {
    $(".mobile-navbar-tab-trigger").removeClass("nav-scrolled");
  }
});
$(document).on('click', '.nav-sticky-footer-block h3:not(.show-nav-countries)', function(){
  var $this = $(this);
  $this.addClass('show-nav-countries');
  $this.addClass('close-countries');
});

$(document).on('click', '.show-nav-countries .arrow-down-link', function(){
  $('.nav-sticky-footer-block h3').removeClass('show-nav-countries').removeClass('close-countries');
});


$(document).on('click', '.active-currency', function(){
  $('.nav-sticky-footer-block h3').removeClass('show-nav-countries').removeClass('close-countries');
})


$(".mobile-navbar-tab-trigger a").click(function(event) {
  $(this).addClass("bold--text"); // add the "bold" class to the clicked link
});

$(".mobile-navbar-nav .product-ribbon-flex-item:not(:last-child)").click(function(event) {
  $(this).find('.top-number').addClass("bold--text"); // add the "bold" class to the clicked link
});


$(function() {
  $.fn.swipe = function( callback ) {
    var touchDown = false,
      originalPosition = null,
      $el = $( this );

    function swipeInfo( event ) {
      var x = event.originalEvent.pageX,
        y = event.originalEvent.pageY,
        dx, dy;

      dx = ( x > originalPosition.x ) ? "right" : "left";
      dy = ( y > originalPosition.y ) ? "down" : "up";

      return {
        direction: {
          x: dx,
          y: dy
        },
        offset: {
          x: x - originalPosition.x,
          y: originalPosition.y - y
        }
      };
    }

    $el.on( "touchstart mousedown", function ( event ) {
      touchDown = true;
      originalPosition = {
        x: event.originalEvent.pageX,
        y: event.originalEvent.pageY
      };
    } );

    $el.on( "touchend mouseup", function () {
      touchDown = false;
      originalPosition = null;
    } );

    $el.on( "touchmove mousemove", function ( event ) {
      if ( !touchDown ) { return;}
      var info = swipeInfo( event );
      callback( info.direction, info.offset );
    } );

    return true;
  };
});



function syncHeight() {
  document.documentElement.style.setProperty(
      '--viewport-main-height',
      `${window.innerHeight}px`
  );
}



document.addEventListener('DOMContentLoaded', function() {
  syncHeight();
});

window.addEventListener('load', function() {
  setTimeout(syncHeight, 300); // delay of 300ms
});

$(document).on('click', '.search-modal__close-button', function(){
  if ($('body').hasClass('template-index') && $(window).width() < 990 && !$('.manually-filtered').length) {
    $('.template-index .fake-filter-slider').slick('slickPlay');
  }
});